import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import Layout from "../../components/global/layout";
import methodModel from "../../methods/methods";
import loader from "../../methods/loader";

const Terms = () => {
  const [content, setContent] = useState(null);
  const slug = "terms_and_condition";

  useEffect(() => {
    getDetail();
  }, [slug]);

  const getDetail = () => {
    loader(true)
    ApiClient.get(`content/detail?slug=${slug}&status=active`).then(res => {
      if (res.success) {
        setContent(res.data)
      }
      loader(false)
    })
  }

  return (
    <Layout>

<div className="bg-white py-10 lg:py-20">

    
      <div className="max-w-3xl mx-auto p-4 bg-white ">
        <h1 className="text-3xl font-semibold text-gray-800 mb-4">{content?.title}</h1>



        <div className="bg-gray-50 rounded-lg">
        {content?.image ? (
          <img
            src={methodModel.noImg(content?.image)} // Assuming noImg is a method that processes the image URL
            alt={content?.title}
            className=" h-96 w-full object-contain mx-auto mb-4" // Increased image size and added margin
          />
        ) : (
          <div className="text-center text-gray-500"></div>
        )}
          </div>
       
        <div
          dangerouslySetInnerHTML={{ __html: content?.description }}
          className="text-gray-700 space-y-4"
        />
      </div>
      </div>
    </Layout>
  );
};

export default Terms;
